export default __webpack_public_path__ + "static/media/university.677e3e44.jpg";